import "./Header.css";
import { Badge } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";



export default function UserCartMenuItem(props) {
  // user cart menu item, displaying the nr of items currently in the cart

    return (
        <>
        <LinkContainer to="/cart" className="navbar-main-button" onClick={props?.toggleNavExpansion}>
          <div >
            <i style={{ fontSize: "large" }} className="bi bi-cart3 "></i>
            {props.quantity && props.quantity > 0 ? (
              <Badge
                style={{
                  position: "relative",
                  bottom: "12px",
                  right: "9px",
                  fontSize: "x-small",
                }}
                pill
                bg="danger"
              >
                {props.quantity}
              </Badge>
            ) : null}
            <span style={{ marginLeft: props.quantity > 0 ? "-7px" : "6px" }}>
              Cart
            </span>
          </div>
        </LinkContainer>
      </>
          );
    
}